import BaseParser from './BaseParser';
import { BaseParserOptions, HumanNameOptions } from './SharedTypes';

const safeGetStringValue = (rawValue: string[]): string => {
  if (!rawValue || !Array.isArray(rawValue) || !rawValue.length) return '';

  return rawValue.join(' ').trim();
};

class HumanName extends BaseParser {
  private options: BaseParserOptions;
  /**
   * @param {boolean} options.humanName.givenOnly - Only parse given name
   * @param {boolean} options.humanName.prefixOnly - Only prefix name
   * @param {boolean} options.humanName.familyOnly - Only family name
   */
  constructor(options = {}) {
    super();
    this.options = options;
  }

  getDisplayValue(fhirProperty: fhir.HumanName): string {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    if (fhirProperty === null || fhirProperty === undefined) return null;

    const { givenOnly, prefixOnly, familyOnly } =
      this.options.humanName || ({} as HumanNameOptions);

    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    const given = safeGetStringValue(fhirProperty?.given);

    if (givenOnly) return given;

    const prefix = fhirProperty?.prefix;
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    if (prefixOnly) return safeGetStringValue(prefix);

    const family = fhirProperty?.family;
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    if (familyOnly) return family;

    const maybeAddSpaceAfter = (val: string) => (val ? `${val} ` : '');
    return (
      maybeAddSpaceAfter(
        safeGetStringValue(
          // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
          prefix,
        ),
      ) +
      maybeAddSpaceAfter(given) +
      (family || '')
    ).trim();
  }
}

export default HumanName;
